export default __webpack_public_path__ + "static/media/agenda_white.1574d881.svg";